import {bookingForAllowedKey} from '@/api/queries/keys/bookingKeys';
import {getUsersMeBookingForAllowed} from '@/api/repositories/booking/BookingForRepository';
import {useQuery} from '@tanstack/vue-query';
import type {MaybeRef} from 'vue';
import {toRef} from 'vue';

export function useBookingForAllowedQuery(enabled: MaybeRef<boolean>) {
    return useQuery({
        queryKey: [...bookingForAllowedKey],
        queryFn: getUsersMeBookingForAllowed,
        enabled: toRef(enabled),
        initialData: [],
        initialDataUpdatedAt: 0,
    });
}
